import { useMediaQuery } from "react-responsive";

export default function useResponsive() {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return {
    isMobile,
    isTablet: isMobile === false,
  };
}
